<template>
  <div>
    <div class="timeline is-centered">
      <header class="timeline-header">
        <span class="tag is-medium is-primary">{{startString}}</span>
      </header>
      <div class="timeline-item" v-for="segment in segments">
        <a :href="segment.purchase_link || 'javascript:void(0)'" style="color: inherit" target="_blank">
          <div class="timeline-marker is-icon"
               v-bind:class="{'is-primary pulse': segment.purchase_link, }">
            <b-icon size="is-small" :icon="iconsMap[segment.type]">
            </b-icon>
          </div>
        </a>
        <div class="timeline-content">

          <p class="heading">{{format(segment.buffered_depart_time)}}</p>
          <p>
            <span class="capital">{{segment.type}}</span>
            <span v-if="segment.type !== 'flight'">with <span class="capital"> {{segment.name}}</span></span>
            for {{price(segment.price)}}
            <span v-if="segment.type === 'ride-share'">*</span>
            <span class="from-string" v-if="segment.segment_coords.data.from_string">
              <br>
              {{segment.segment_coords.data.from_string}}
            </span>
            <span class="from-string" v-if="segment.segment_coords.data.to_string">
              to {{segment.segment_coords.data.to_string}}
            </span>
            <span class="time-subscript" v-if="segment.type === 'flight'">
              <br>
              time includes 90m early arrival
            </span>
            <span v-if="segment.type === 'bus'" class="time-subscript">
            <br>
            times includes 20m early arrival
            </span>
          </p>

        </div>
      </div>
      <div class="timeline-header">
        <span class="tag is-medium is-primary">{{endString}}</span>
      </div>
      <span
        style="margin-top: 15px;">* Price is an estimate. Ride-share potentially replaceable with public transit. </span>
    </div>

  </div>
</template>

<script>
  import axios from 'axios';
  import format from 'date-fns/format'
  export default {
    name: 'Timeline',
    props: ['segments', 'startString', 'endString'],
    data() {
      return {
        iconsMap: {
          'ride-share': 'uber',
          'drive': 'car',
          'bus': 'bus',
          'flight': 'airplane'
        }
      };
    },
    methods: {
      format: function (dt) {
        return format(dt, 'h:mma')
      },
      price: function (p) {
        if (p)  return "$" + Number.parseFloat(p).toFixed(2)
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  @keyframes pound {
    from {
      transform: none;
    }
    50% {
      transform: scale(1.4);
    }
    to {
      transform: none;
    }
  }

  .pulse {
    /* ... */
    animation: pound 2s infinite;
  }

  .time-subscript {
    font-size: xx-small;
    font-style: italic;
  }

  .capital {
    text-transform: capitalize;
  }

  .from-string {
    font-size: x-small;
  }

</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue